// eslint-disable-next-line
import {Icon, LatLngBounds, map, marker, tileLayer} from 'leaflet/src/Leaflet';

/**
 * DesktopMenu Module
 * helper class
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.mapContainer = document.querySelector('[data-map-id]');

    if (!this.mapContainer) {
      return;
    }

    this.latitude = this.mapContainer.dataset.mapLatitute;
    this.longitude = this.mapContainer.dataset.mapLongitude;
    this.latLongArray = JSON.parse(this.mapContainer.dataset.mapLonglats);

    this.myMap = map('mapid', { scrollWheelZoom: false })
      .setView([this.latitude, this.longitude], 14);

    tileLayer('{id}/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        id: '/services/map',
      }).addTo(this.myMap);

    Icon.Default.imagePath = '/resources/global/img/';

    this.latLongArray.forEach((longLat) => {
      marker([longLat[0], longLat[1]]).addTo(this.myMap);
    });

    if (this.latLongArray.length > 1) {
      this.myMap.fitBounds(new LatLngBounds(this.latLongArray));
    }
  }
}
